function scrollFunction() {
	var body = jQuery('body.t--no-touch');
	100 < document.body.scrollTop || 120 < document.documentElement.scrollTop
		? body.addClass('t-body--scrolled')
		: body.removeClass('t-body--scrolled');
}
function is_touch_device() {
	try {
		document.createEvent('TouchEvent');
		return true;
	} catch (e) {
		return false;
	}
}
jQuery(document).ready(function ($) {
	// Accessibility Function
	t_accessibility_navigation();

	function t_accessibility_navigation() {
		// Accessibility Updates for Main Navigation
		$('.menu > li.wp__menu-item-has-children').attr('aria-haspopup', 'true');
		$('.menu > li.wp__menu-item-has-children > .sub-menu').attr(
			'aria-hidden',
			'true'
		);

		$('.menu > li.wp__menu-item-has-children a').on(
			'mouseenter focus',
			function () {
				menuWithChildren = $(this).parents('li.wp__menu-item-has-children');
				hasFocus = menuWithChildren.hasClass('focus');
				if (!hasFocus) {
					menuWithChildren.addClass('focus');
					menuWithChildren.find('> .sub-menu').removeAttr('aria-hidden');
				}
			}
		);
		$('.menu > li.wp__menu-item-has-children a').on(
			'blur mouseleave',
			function () {
				menuWithChildren = $(this).parents('li.wp__menu-item-has-children');
				hasFocus = menuWithChildren.hasClass('focus');
				if (hasFocus) {
					menuWithChildren.removeClass('focus');
					menuWithChildren.find('> .sub-menu').attr('aria-hidden', 'true');
				}
			}
		);
		// Pushy Menu
		var pushyMenu = $('nav.pushy');
		var menuButton = $('a.menu-btn');
		var siteOverlay = $('.site-overlay');

		// Toggle pushy visibility to screen Readers according to if it's opened or closed
		function toggleMenu() {
			var expanded = menuButton.attr('aria-expanded');
			if (expanded === 'true') {
				menuButton.attr('aria-expanded', 'false');
				pushyMenu.attr('hidden', 'hidden');
			} else {
				menuButton.attr('aria-expanded', 'true');
				pushyMenu.removeAttr('hidden');
			}
		}
		// call toggleMenu on open and close buttons click
		menuButton.on('click', toggleMenu);
		siteOverlay.on('click', toggleMenu);
	}

	if (is_touch_device()) {
		$('body').addClass('t--touch-device');
		$(document).on('touchstart click', function () {
			// close any open menu when the user click or touch any part in the page
			$('.menu > li.wp__menu-item-has-children').removeClass('focus');
		});
		$('.menu > li.wp__menu-item-has-children > ul > li > a').on(
			'touchstart',
			function (e) {
				// keep the menu open when touching it or any link insides it, for click event to redirect normally
				e.stopPropagation();
			}
		);
		$('.menu > li.wp__menu-item-has-children > a').on(
			'touchstart click',
			function (e) {
				// prevent anchor from redirecting
				e.preventDefault();

				//prevent code on line 5 to line 8 from executing
				e.stopPropagation();

				// Remove any hover class from other menus to get it closed
				$('.menu > li.wp__menu-item-has-children')
					.not($(this).parent())
					.removeClass('focus');

				// toggle hover class to show/hide menu on click
				$(this).parent().toggleClass('focus');
			}
		);
	} else {
		// needed this to add hover only for non touch devices
		$('body').addClass('t--no-touch');
		var currentMenuItem = $('.menu > li > ul').find('li.wp__current-menu-item');
		if (
			currentMenuItem &&
			!currentMenuItem.parent().parent().hasClass('wp__current-page-ancestor')
		) {
			currentMenuItem.parent().parent().addClass('wp__current-page-ancestor');
		}
	}

	// Tabbed content Next & Previous buttons
	const container = $('.t-tabbed-content__container');
	if (container) {
		const tabListWrapper = $('.t-tabbed-content-tab-toggle');
		const tabList = $('.t-tabbed-content-tab-toggle ul');
		let tabListWidth = 0;
		for (let i = 0; i < tabList.children().length; i++) {
			tabListWidth += tabList.children()[i].offsetWidth;
		}
		if (tabListWidth > tabListWrapper.width() && screen.width >= 768) {
			container.append(
				'<button class="next"><i class="fa-solid fa-chevron-right"></i></button>'
			);
			container.append(
				'<button class="prev disabled"><i class="fa-solid fa-chevron-left"></i></button>'
			);
		}

		const nextButton = $('.t-tabbed-content__container .next');
		const prevButton = $('.t-tabbed-content__container .prev');

		const maxScrollRight = tabList[0].scrollWidth - tabListWrapper.width();

		const onNext = () => {
			if (Math.round(tabList.scrollLeft() + 400) >= maxScrollRight) {
				nextButton.addClass('disabled');
			}
			prevButton.removeClass('disabled');
			tabList.scrollLeft(tabList.scrollLeft() + 400);
		};

		const onPrev = () => {
			if (Math.round(tabList.scrollLeft() - 400) <= maxScrollRight) {
				if (Math.round(tabList.scrollLeft() - 400) <= 0)
					prevButton.addClass('disabled');
			}
			nextButton.removeClass('disabled');
			tabList.scrollLeft(tabList.scrollLeft() - 400);
		};

		nextButton.on('click', () => {
			onNext();
		});

		prevButton.on('click', () => {
			onPrev();
		});

		document.addEventListener('keydown', (e) => {
			if (e.code === 'ArrowRight') onNext();
			if (e.code === 'ArrowLeft') onPrev();
		});
	}
});
jQuery(window).on('load scroll', function () {
	scrollFunction();
});
